import { NgClass } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, isDevMode } from '@angular/core';
import { RouterModule } from '@angular/router';

import {
    provideB2cAuthentication,
    withAccessTokenInterceptor,
} from '@mobi/b2c-authentication-ng-jslib';
import {
    MobiUiConciergeComponents,
    MobiUiContactPersonComponents,
    MobiUiFooterComponents,
    MobiUiHeaderComponents,
    MobiUiIconComponents,
    MobiUiMessagesComponents,
    MobiUiPopoverComponents,
    MobiUiSplitButtonComponents,
} from '@mobi/rwc-ui-components-ng-jslib';

import { SharedModule } from '../shared/shared.module';
import { TranslationModule } from '../shared/translation/translation.module';

import { ConciergeComponent } from './layout/footer/concierge/concierge.component';
import { ConciergeProtektaComponent } from './layout/footer/concierge-protekta/concierge-protekta.component';
import { ContactComponent } from './layout/footer/contact/contact.component';
import { ContactProtektaComponent } from './layout/footer/contact-protekta/contact-protekta.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HeaderComponent } from './layout/header/header.component';
import { MessagesComponent } from './layout/header/messages/messages.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { OauthModule } from './oauth/oauth.module';

@NgModule({
    declarations: [
        LayoutComponent,
        HeaderComponent,
        FooterComponent,
        ConciergeComponent,
        MessagesComponent,
        ContactComponent,
        ConciergeProtektaComponent,
        ContactProtektaComponent,
    ],
    imports: [
        SharedModule,
        RouterModule,
        MobiUiHeaderComponents,
        MobiUiFooterComponents,
        TranslationModule,
        MobiUiIconComponents,
        MobiUiConciergeComponents,
        MobiUiPopoverComponents,
        MobiUiMessagesComponents,
        MobiUiContactPersonComponents,
        OauthModule,
        MobiUiSplitButtonComponents,
        NgClass,
    ],
    exports: [LayoutComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        provideB2cAuthentication(
            {
                clientIds: {
                    preprod: 'cec76f84c2bbb8c1cb0e48aae591a645',
                    prod: 'f032030f711bb00e0f2d1b45c93fc325',
                },
                isE2eTestMode: isDevMode(),
                redirectUri: `${location.origin}/accept-code`,
                options: { postLoginRoute: '/accept-code' },
            },
            withAccessTokenInterceptor({
                unauthenticated: [
                    new RegExp('/public/'),
                    new RegExp('/static/'),
                    new RegExp('/att/attachmentstore/'),
                ],
            }),
        ),
    ],
})
export class CoreModule {}
